import React, { useState, useRef } from "react";

const MentionsInput = ({ value, onChange, options, placeholder }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [filter, setFilter] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(0);
  const textareaRef = useRef(null);

  const handleKeyDown = (e) => {
    if (showOptions) {
      const filteredOptions = getFilteredOptions();
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev + 1) % filteredOptions.length);
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex((prev) => (prev - 1 + filteredOptions.length) % filteredOptions.length);
      } else if (e.key === "Enter" || e.key === "Tab") {
        e.preventDefault();
        if (filteredOptions[selectedIndex]) {
          insertMention(filteredOptions[selectedIndex]);
        }
      } else if (e.key === "Escape") {
        setShowOptions(false);
      }
    }
  };

  const getFilteredOptions = () => {
    if (!filter) return options.slice(0, 50);
    return options
      .filter((opt) => (opt.friendly_name || "").toLowerCase().includes(filter.toLowerCase()))
      .slice(0, 50);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);

    const pos = e.target.selectionStart;
    const textBefore = val.slice(0, pos);
    
    // match @ or / followed by word characters
    const match = textBefore.match(/[@/]([^@/]*)$/);
    if (match) {
      setShowOptions(true);
      setFilter(match[1]);
      setSelectedIndex(0);
      
      // Calculate approximate position
      // In a real app we'd use get-caret-coordinates package, but here we center it below or at the bottom
    } else {
      setShowOptions(false);
    }
  };

  const insertMention = (option) => {
    const val = textareaRef.current.value;
    const pos = textareaRef.current.selectionStart;
    const textBefore = val.slice(0, pos);
    const textAfter = val.slice(pos);
    
    const match = textBefore.match(/[@/]([^@/]*)$/);
    if (match) {
      const startPos = pos - match[0].length;
      const newTextBefore = val.slice(0, startPos);
      const mentionText = `@[${option.friendly_name}]`;
      const newText = newTextBefore + mentionText + " " + textAfter;
      onChange(newText);
      setShowOptions(false);
      
      setTimeout(() => {
        if (textareaRef.current) {
          const newCursorPos = startPos + mentionText.length + 1;
          textareaRef.current.selectionStart = newCursorPos;
          textareaRef.current.selectionEnd = newCursorPos;
          textareaRef.current.focus();
        }
      }, 0);
    }
  };

  const filteredOptions = getFilteredOptions();

  return (
    <div className="mentions-input-container" style={{ position: "relative" }}>
      <textarea
        ref={textareaRef}
        className="form-control"
        value={value}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        rows={4}
        onClick={() => setShowOptions(false)}
        onBlur={() => {
          setTimeout(() => setShowOptions(false), 200);
        }}
      />
      
      {showOptions && filteredOptions.length > 0 && (
        <div 
          className="mentions-menu list-group shadow" 
          style={{ 
            position: "absolute", 
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
            width: "100%",
            backgroundColor: "white",
            top: "100%"
          }}
        >
          {filteredOptions.map((opt, index) => (
            <button
              key={opt.id}
              type="button"
              className={`list-group-item list-group-item-action ${index === selectedIndex ? "active" : ""}`}
              onMouseDown={(e) => {
                e.preventDefault(); // Prevent blur
                insertMention(opt);
              }}
              onMouseEnter={() => setSelectedIndex(index)}
            >
              {opt.friendly_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MentionsInput;
